module.exports = __webpack_public_path__ + "static/media/3.5984dd24.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/3.mp3
// module id = 82
// module chunks = 0